import ChatPanelHeader from './ChatPanelHeader'

export default ChatPanelHeader
